import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text } from "@ui-component-library";

const StatsSection = (props) => {
  const theme = (() => {
		switch (props.theme) {
			case 'white':
				return {
          backgroundColor: 'bg-[#FFFFFF]',
          textColor: 'text-[#0F0F0F]',
        };
			case 'stone':
				return {
          backgroundColor: 'bg-[#F6F5F4]',
          textColor: 'text-[#0F0F0F]',
        };
			default:
				return {
          backgroundColor: 'bg-[#FFFFFF]',
          textColor: 'text-[#0F0F0F]',
        };
		}
	})();

	const items = [
		{
			title: '52,000+',
			text: 'Skogsägare använder Treebula',
		},
		{
			title: '4,000,000+',
			text: 'Hektar skogsbruksplaner',
		},
		{
			title: '1 plats',
			text: 'För skogens alla möjligheter',
		},
	];

  return (
    <TailwindWrapper>
			<div className={`${theme.backgroundColor} ${theme.textColor}`}>
				<section className={`flex flex-wrap items-center justify-center container text-center gap-[48px] lg:gap-0 py-[48px] lg:py-[96px]`}>
					{items.map((item, index) => (
						<div key={index} className="w-full lg:w-1/3">
							<Text tw variant="text-4xl/leading-normal/medium" className="mb-3">
								{item.title}
							</Text>
							<Text tw variant="text-base/leading-normal/normal">
								{item.text}
							</Text>
						</div>
					))}
				</section>
			</div>
    </TailwindWrapper>
  );
};

StatsSection.defaultProps = {
  theme: "white",
};

StatsSection.fields = {
  theme: {
    type: "select",
    label: "Theme",
    options: [
      { label: "White", value: "white" },
      { label: "Stone", value: "stone" },
    ],
  },
};

export default StatsSection;
